import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=32c6c6de&scoped=true&"
import script from "./CouponDetail.vue?vue&type=script&lang=ts&"
export * from "./CouponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=32c6c6de&lang=scss&scoped=true&"
import style1 from "./CouponDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6c6de",
  null
  
)

export default component.exports